import type { QueryActionCreatorResult } from '@reduxjs/toolkit/query';

export const wrapQueryResult = async <T extends QueryActionCreatorResult<any>>(
  queryResult: T
): Promise<void> => {
  await queryResult;
};